
<div class="px-4 sm:px-8 lg:px-[74px] py-6 sm:py-10">
  <form #mergeGridForm="ngForm">
  <h2 class="text-2xl sm:text-3xl text-gray-900 text-center font-bold mb-6">Merge Grid</h2>


  <div class="flex mb-6">
    <div class="w-[800px] max-w-full mx-auto">

        <div class="upload-box" (drop)="onDrop($event)" (dragover)="allowDrop($event)" (dragenter)="allowDrop($event)" (click)="fileInput.click()">
          <span>
            <img src="../../../../../../../assets/theme/images/icons/photo-plus.svg"  alt="photo-plus"
            class="w-6 h-6 cursor-pointer" />
          </span>
          <p>
            Click to Add or Drag & Drop Images</p>
          <input
          #fileInput
          type="file"
          accept="image/*"
          class="hidden"
          multiple
          required
          (change)="onSelect($event)"/>
        </div>
        @if(this.fileError){
          <span class="text-danger">{{fileError}}</span>
        }

    </div>
  </div>

  <div class="mx-auto">



    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-4 w-full lg:w-[800px] max-w-full mx-auto">

      <div class="w-full lg:w-auto lg:flex-1 lg:min-w-0 min-h-[420px] shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white bg-nav-tabs">
        <ul class="flex flex-nowrap items-center text-nowrap cursor-pointer mb-2 list-none p-0 m-0 overflow-x-auto">
          <li class="nav-item">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Original'}"
                  (click)="setTab('Original')">
                  See Images
              </a>
          </li>
          <li class="nav-item ms-2">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Merge-Grids'}" (click)="setTab('Merge-Grids')">
                  Merged Grid
              </a>
          </li>
          @if (mergeGridRequestModel.images.length) {
            <div class="ms-auto mt-2">
              <span>
                <img (click)="clear()" src="../../../../../../../assets/images/reset.svg" title="reset" alt="reset" height="18" width="18"
                  class="w-6 h-6 cursor-pointer" />
              </span>
            </div>
          }
      </ul>




      @if(activeTab === 'Original') {
        @if(!mergeGridRequestModel.images.length){
          <div class="image-preview1">
            <p>No images added yet</p>
          </div>
          }
        <div class="preview-row">
          @for (image of images; track $index; let i = $index) {
            <div  class="small-image-box">
              <img [src]="image" class="small-image" />
              <button class="tiny-remove-btn" (click)="removeImage(i)" title="Remove">
                ✕
              </button>
            </div>
          }
        </div>
      }
          @else {
            @if(isLoading) {
              <div class="h-[400px] w-full bg-gray-400 rounded animate-pulse"></div>
             }
             @else if(!mergeGridRequestModel.images.length){
              <div class="image-preview1">
                <p>No images added yet</p>
              </div>
              }
             @else if( this.mergeGridResponseModel.base64_image){
              <div class="image-preview1">
                <img tabindex="0" (click)="preview()" src="./assets/theme/images/icons/Eye-password-Black.svg" alt="Eye-password-Black" class="eye-icon" />
                <img [src]="getImageSource" alt="Merged Grid" />
              </div>
             }

          }



      </div>

      <div class="w-full lg:w-80 shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white">
        <div class="mb-1">
          <label for="spacing" class="block mb-1 text-sm font-medium text-black flex justify-between">
            <span>Spacing</span>
            <span class="text-black">{{ mergeGridRequestModel.spacing }}</span>
          </label>
          <input
            type="range"
            [min]="0"
            [max]="100"
            [step]="1"
            (input)="onSpacingChange($event)"
            [value]="mergeGridRequestModel.spacing"
            id="spacing"
            class="w-full accent-black"
          />
        </div>
        <div class="mb-1">
          <label for="margins" class="block mb-1 text-sm font-medium text-black flex justify-between">
            <span>Margin</span>
            <span class="text-black">{{ mergeGridRequestModel.margin }}</span>
          </label>
          <input
            type="range"
            [min]="0"
            [max]="100"
            [step]="1"
            (input)="onMarginChange($event)"
            [value]="mergeGridRequestModel.margin"
            id="margins"
            class="w-full accent-black"
          />

        </div>
        <div class="flex gap-2 w-full">
          <div class="mb-1 flex-1 min-w-0">
            <label for="rows" class="block mb-1 text-sm font-medium">Rows</label>
            <input  type="number"  required name="rows" #rows="ngModel" id="rows"
              [(ngModel)]="mergeGridRequestModel.rows"
              [min]="1"
              class="border border-gray-300 rounded-md px-3 py-2 w-full min-w-0" />
            <app-form-validator [control]="rows" [fieldName]="'Row'"></app-form-validator>
          </div>
          <div class="mb-1 flex-1 min-w-0">
            <label for="cols" class="block mb-1 text-sm font-medium">Columns</label>
            <input  type="number"  required name="cols" #cols="ngModel" id="cols"
              [(ngModel)]="mergeGridRequestModel.cols"
              [min]="1"
              class="border border-gray-300 rounded-md px-3 py-2 w-full min-w-0" />
            <app-form-validator [control]="cols" [fieldName]="'Column'"></app-form-validator>
          </div>
        </div>
        <div class="mb-1">
          <button  (click)="mergeGrid()" [disabled]="!mergeGridForm.valid"
            class="flex items-center justify-center py-3 w-full rounded-full text-base leading-5
             text-white font-medium bg-black">
             Merge Grid Images
            @if(isLoading){
            <span
              class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
            }
          </button>
        </div>
        @if (mergeGridResponseModel.base64_image) {
          <button type="submit" (click)="downloadImage()" [disabled]="!mergeGridForm.valid"
            class="flex items-center justify-center py-3 w-full rounded-full text-base leading-5
             text-white font-medium bg-black">
             Download Image
            @if(isDownloading){
            <span
              class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
            }
          </button>
        }
      </div>
    </div>

  </div>


</form>
</div>
